import { render, staticRenderFns } from "./filePrev.vue?vue&type=template&id=667bfcbb&scoped=true&"
import script from "./filePrev.vue?vue&type=script&lang=js&"
export * from "./filePrev.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667bfcbb",
  null
  
)

export default component.exports